var CustomSidebar = class extends HTMLElement {
  constructor() {
    super();
    this.initSidebar()
  }
  initSidebar() {
    if (this.closest('main') && !Shopify.designMode) {
      this.closest('main').classList.add('has-sidebar');
    }

    let self = this;
    var sidebarItems = this.querySelectorAll('.sidebar-menu__item');
    sidebarItems.forEach(function(item) {
      item.querySelector('a').addEventListener('click', function(e) {
        self.handleSidebarItemClick(e, item);
      });
    });
  }
  handleSidebarItemClick(e, item) {
    if (item.classList.contains('active')) {
      e.preventDefault();
      var siblings = Array.prototype.filter.call(item.parentNode.children, function(child) {
        return child !== item;
      });
      siblings.forEach(function(sibling) {
        if (sibling.classList.contains('is-show')) {
          sibling.classList.remove('is-show');
          item.classList.remove('opening');
        } else {
          sibling.classList.add('is-show');
          item.classList.add('opening');
        }
      });
    }
  }
};
if (!window.customElements.get('custom-sidebar')) {
  window.customElements.define('custom-sidebar', CustomSidebar);
}
